<template>
  <div class="bodybox">
    <div class="columnBox">
      <div class="columnBoxInnner">
        <div class="columnBoxInnnerList">
          <div v-for="(item,index) in columnlist" :key="index" :class="currrentcolumn==index?'activename':'column_a'" @click="changeNowColumn(item.value,index)">
            <span class="nameshow">{{ item.name }}</span><span v-show="index<columnlist.length-1" class="a_span">/</span>
          </div>
        </div>
      </div>
      <Centerlistnews :columnlist="currentData" :isdoc="isLibrary" />
      <div
        v-if="currentData.length<=0"
        style="text-align: center;
         font-size: 20px;
         color: rgb(161, 157, 158);
         font-weight: 600;
         background-color: rgb(255, 255, 255);
          height: 150px;
          line-height: 150px;"
      >
        暂无数据
      </div>
      <div v-if="loadAll" class="atfoot loadMore">
        已经到底部了
      </div>
      <div v-else class="loadMore" @click="addMore">
        <span v-show="!isloading">加载更多>></span>
        <span v-show="isloading" class="el-icon-loading" style="font-size: 16px" />
      </div>
    </div>
  </div>
</template>
<script>

import Centerlistnews from '@/components/centerlist_library/index.vue'
import { addMorenNews } from '@/api/api.js'

export default {
  components: { Centerlistnews },
  props: ['columnlist', 'alldata'],
  data() {
    return {
      isloading: false,
      currentPage: 1,
      contentTypeIds: '',
      currrentcolumn: 0,
      loadAll: false,
      page: 1,
      currentData: this.alldata.content.listMapData,
      templateId: 'DOC',
      isLibrary: true,
      count: ''
    }
  },
  computed: {

  },
  created() {

  },
  mounted() {
    this.page = this.alldata.content.page
    if (this.page == this.currentPage * 1 && this.page == 0) {
      this.loadAll = true
    }
    if (this.page == 0) {
      this.page = 1
    }
    if (this.page == 1) {
      this.loadAll = true
    }
  },
  methods: {
    changeNowColumn: function(ID, index) {
      var obj = {}
      obj.templateId = this.templateId
      obj.index = '1'
      obj.size = '12'
      if (ID) {
        obj.contentTypeIds = ID
      }
      this.contentTypeIds = ID
      this.currentPage = 1
      this.currrentcolumn = index
      this.loadAll = false
      addMorenNews(obj).then(res => {
        this.currentData = []
        this.currentData = this.currentData.concat(res.data.listMapData)
        this.count = res.data.count
        if (this.count == 0) {
          this.page = 1
        } else {
          this.page = Math.ceil(this.count / 8)
        }
        if (this.currentPage == this.page) {
          this.loadAll = true
        }
      })
    },
    // /加载更多
    addMore: function() {
      this.isloading = true
      var obj = {}
      obj.templateId = this.templateId
      if (this.contentTypeIds) {
        obj.contentTypeIds = this.contentTypeIds
      }
      obj.index = this.currentPage + 1
      obj.size = '12'
      addMorenNews(obj).then(res => {
        this.currentData = this.currentData.concat(res.data.listMapData)
        this.isloading = false
        this.currentPage += 1
        if (this.currentPage >= this.page) {
          this.loadAll = true
        }
      })
    }
  }

}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .columnBoxInnnerList{
    height: 60px;
    line-height: 60px;
    background-color: #fff;
  }
    .bodybox{
        background-color: #fafafa;
    }
    .columnBox{
        margin: 20px auto;
        margin-top: 0;
        text-align: center;
        padding-top: 20px;
        .activename{
            display: inline-block;
            cursor: pointer;
            .a_span{
                margin: 0 16px;
            }
            .nameshow{
                color: #ed4040;
                font-size: 16px;
              font-weight: 600;
            }

        }
        .column_a{
            display: inline-block;
            cursor: pointer;
            font-size: 16px;
            .a_span{
                margin: 0 16px;
            }
            .nameshow{
                font-size: 16px;
                color: #333333;
                font-weight: 600;
                &:hover{
                    color: #ed4040;
                }
            }
        }
      .loadMore{
        height: 45px;
        line-height: 45px;
        font-size: 14px;
        color: #999999;
        background-color: #fff;
        border: 1px solid #e5e5e5;
        border-radius: 3px;
        cursor: pointer;
        display:inline-block;
        width: 100%;
        margin-top: 20px;
        transition: 0.5s;
        &:hover{
          color: #ed4040;
          border: 1px solid #ed4040;
        }
      }
        .atfoot{
            cursor: auto;
        }
    }
</style>
<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .columnBox{
      min-height: 80vh;
    }
    .columnBoxInnner{
      width: 100%;
      overflow: hidden;
      padding-bottom: 20px;
      overflow-x: auto;
      .columnBoxInnnerList{
        white-space: nowrap;
        padding: 0 20px;
      }
    }
  }
</style>
